import { Navigate } from "react-router-dom";
import { FaHeart } from "react-icons/fa";
import { WishlistViewMain } from "../Components/WishlistViewMain";
import { WishlistCategoryViewMain } from "../Components/WishlistCategoryViewMain";

export const WishlistModule = () => [
    {
        views: "PRIVATE", path: "/wishlist/archived", component: <Navigate to="/archive" replace />,
        roles: null, permissions: null, label: "Archivados", icon: null,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false,
        isBlockedWhenLogged: false,
    },
    {
        views: "PRIVATE", path: "/wishlist/:categoryId", component: <WishlistCategoryViewMain />,
        roles: null, permissions: null, label: "Categoría de Wish List", icon: null,
        displayInHeader: false, displayInFooter: false, displayInSidebar: false,
        isBlockedWhenLogged: false,
    },
    {
        views: "PRIVATE", path: "/wishlist", component: <WishlistViewMain />,
        roles: null, permissions: null, label: "Wish List", icon: <FaHeart />,
        displayInHeader: false, displayInFooter: false, displayInSidebar: true,
        isBlockedWhenLogged: false,
    },
];
